import {
    AutoComplete,
    Button,
    Col,
    Collapse,
    DatePicker,
    Form,
    Input,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Card,
    Table,
} from "antd";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { generateBlob } from "../../Utils/CreateBlob";
import './Saving.css';
import {
    existAccount,
    generateAccountDetailsReport,
    generateActiveAndDormantDeposits,
    generateActiveAndDormantwasamwiseDeposits,
    generateCDPDReport,
    generateCDPDWasamWiseReport,
    generateDepositsummaryBranchReport,
    generateDepositSummaryReport,
    generateDormantDepositSummaryReport,
    generateMonthlyAllWasamReport,
    generateSamurdhiBankDepositSummaryReport,
    generateSamurdhiBankOtherAccountDistrictWise,
    generateSamurdhiBankOtherDepositsDistrictWise,
    generateSamurdhiBankOtherDepositSummaryReport,
    generateSamurdhiBankProductWiseReport,
    generateSamurdhiBankShareAccountReport,
    generateSamurdhiBankShareAccountReportDistrictWise,
    generateSamurdhiBankShareDormantDistrictWise,
    generateWasamReports,
    getAllDepositsProducts,
    getAllWasamsByBranchId,
    getDistrictBranches,
    getDivAreaBranches,
    generateDepositCustomerCountReport,
    generateBackdateActiveAndDormantReport,
    displayValue,
    sharesCount,
    generateDormantDepositsCumulativeReport,
    generateDormantDepositsCumulativeBranchReport,
    generateDormantDepositsCumulativeByBranchReport,
    generateActiveAndDormantwasamwise,
    fieldCollectionReport,
    SavingCertificateReport,
    getDistrictDivisionalBranchDetails,
    getAllClosedAccounts,
    generateClosedAccountListExcel,
    generateClosedAccountListPdf,
    getAllAccountList,
    generateAccountListExcel,
} from "./SavingService";

import DepositSummaryIslandReport from "./DepositSummaryIslandReport";
import { disabledDate } from "../../Utils/Util";
import { errHandler } from "../../helper/helper";
import CustomFooter from "../../Layout/CustomFooter";
import DistrictReport from "./DistrictReport";
import ShareMemberDReport from "./ShareMemberDReport";
import ProductWiseReports from "./ProductWiseReports";
import DepositSummary from "./DepositSummary";
import OtherDReport from "./OtherDReport";
import FieldCollectionSummary from "./FieldCollectionSummary";
import MonthlyDormantDeposits from "./MonthlyDormantDeposits";
import AccountList from "./AccountList";
import ClosedAccounts from "./ClosedAccounts";
import InactiveAccounts from "./InactiveAccounts";
import OpenAccountReport from "./OpenAccountReport";
import NonPriorityCustomerAccountsReport from "./NonPriorityCustomerAccountsReport";
import PermissionPanel from "../../Layout/PermissionPanel";
import InterestPay from "./InterestPay";

import { exportCustomerDetailsExcelReport } from "../../Utils/AccountListExcelExport";
import { exportClosedAccountsExcelReport } from "../../Utils/ClosedAccountExcelExport";
import BranchLocationSelector from "../BranchLocationSelector";

const createDistrictData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            districtId: post.districtId,
            districtName: post.districtName,
            districtCode: post.districtCode,
            provinceId: post.provinceId,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }

    }))
    return convertedData;
};

const createWasamData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            wastId: post.wastId,
            wasCode: post.wasCode,
            wasName: post.wasName
        }
    }))
    return convertedData;
};

const createDepositsProductData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            productId: post.productId,
            productCode: post.productCode,
            productName: post.productName
        }
    }))
    return convertedData;
};

const getStatusLabel = (status) => {
    switch (status) {
        case 'all':
            return 'All Accounts';
        case 'active':
            return 'Active Accounts';
        case 'inactive':
            return 'Inactive Accounts';
        case 'closed':
            return 'Closed Accounts';
        default:
            return 'Unknown Status';
    }
};

const activeStatus = [
    {
        value: 0,
        label: "Active accounts"
    },
    {
        value: 1,
        label: "Dormant accounts"
    }
]

const activeDormantAllStatus = [
    {
        value: 0,
        label: "Active accounts"
    },
    {
        value: 1,
        label: "Dormant accounts"
    },
    {
        value: 2,
        label: "All accounts"
    }
]

const transactionType = [
    {
        value: 0,
        label: "CD"
    },
    {
        value: 1,
        label: "PD"
    },
    {
        value: 2,
        label: "CW"
    },
    {
        value: 3,
        label: "LP, LPF"
    },
    {
        value: 4,
        label: "CDF"
    },

]

const AllOrWasam = [
    {
        value: 0,
        label: "All"
    },
    {
        value: 1,
        label: "Wasam Wise"
    }
]

const Savings = () => {
    const [loading, setLoading] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);
    const [districtDate, setDistrictDate] = useState(null);
    const [districtBranchData, setDistrictBranchData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedShareDepositDistrict, setselectedShareDepositDistrict] = useState(null);
    const [selectedDivisionalArea, setSelectedDivisionalArea] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [depositLoading, setDepositLoading] = useState(false);
    const [districtLoading, setDistrictLoading] = useState(false);
    const [districtDepositLoading, setDistrictDepositLoading] = useState(false);
    const [districtsLoading, setDistrictsLoading] = useState(false);
    const [accountLoading, setAccountLoading] = useState(false);
    const [otherDepositLoading, setOtherDepositLoading] = useState(false);
    const [productWiseLoading, setProductWiseLoading] = useState(false);
    const [cdpdLoading, setCdpdLoading] = useState(false);
    const [cdpdWasamWiseLoading, setCdpdWasamWiseLoading] = useState(false);
    const [shareAccountDistrictDate, setShareAccountDistrictDate] = useState(null);
    const [shareAccoutLoading, setShareAccountLoading] = useState(false);
    const [otherDistrictDate, setOtherDistrictDate] = useState(false);
    const [otherDistrictLoading, setOtherDistrictLoading] = useState(false);
    const [shareDormantDistrictDate, setShareDormantDistrictDate] = useState(null);
    const [dormantActiveDate, setDormantActiveDate] = useState(null);
    const [dormantActiveWasamwiseDate, setDormantActiveWasamwiseDate] = useState(null);
    const [shareDormantLoading, setShareDormantLoading] = useState(false);
    const [otherAccountDate, setOtherAccountDate] = useState(null);
    const [otherAccountLoading, setOtherAccountLoading] = useState(null);
    const [selectedDormantDistrict, setSelectedDormantDistrict] = useState("");
    const [selectedOtherDepositDistrict, setSelectedOtherDepositDistrict] = useState("");
    const [selectedShareAndMemberDistrict, setSelectedShareAndMemberDistrict] = useState("");
    const [selectedShareAndDormantDistrict, setSelectedShareAndDormantDistrict] = useState("");
    const [selectedAccountDetailsDistrict, setSelectedAccountDetailsDistrict] = useState("");
    const [depositsProducts, setDepositsProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedStatusWasamwise, setSelectedStatusWasamwise] = useState(null);
    const [selectedTransactionType, setSelectedTransactionType] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedBsDates, setSelectedBsDates] = useState(null);
    const [selectedBackDates, setSelectedBackDates] = useState(null);
    const [date, setDate] = useState(null);
    const [isOn, setIsOn] = useState(false);
    const [isExcelForDepositAndDormant, setIsExcelForDepositAndDormant] = useState(false);
    const [isExcelForDepositAndDormantCumulative, setIsExcelForDepositAndDormantCumulative] = useState(false);
    const [isExcelForOtherReports, setIsExcelForOtherReports] = useState(false);
    const [isOnDistrict, setIsOnDistrict] = useState(false);
    const [isOnShareDeposit, setIsOnShareDeposit] = useState(false);
    const [isOnAccount, setIsOnAccount] = useState(false);
    const [isOnOtherDepositsDistrict, setIsOnOtherDepositsDistrict] = useState(false);
    const [isOnShareAndMemberDistrict, setIsOnShareAndMemberDistrict] = useState(false);
    const [isOnShareAndDormantDistrict, setIsOnShareAndDormantDistrict] = useState(false);
    const [wasamData, setWasamData] = useState([]);
    const [selectedWasam, setSelectedWasam] = useState(null);
    const [productAndWasamWiseLoading, setProductAndWasamWiseLoading] = useState(false);
    const [selectedWasamWiseProduct, setSelectedWasamWiseProduct] = useState(null);
    const [selectedMonthlyProductWise, setSelectedMonthlyProductWise] = useState(null);
    const [selectedMonthlyDates, setSelectedMonthlyDates] = useState([]);
    const [dormantAndActiveLoading, setDormantAndActiveLoading] = useState(false);
    const [selectedDormantAndActive, setSelectedDormantAndActive] = useState(null);
    const [selectedAllWasam, setSelectedAllWasam] = useState(null);
    const [monthlyLoading, setMonthlyLoading] = useState(false);
    const [selectCdPdDates, SetselectCdPdDates] = useState([]);
    const [isProductWiseBackDate, setIsProductWiseBackDate] = useState(false);
    const [savingCertificateProduct, setSavingCertificateProduct] = useState(null); // State for selected product in Saving Certificate
    const [savingCertificateWasam, setSavingCertificateWasam] = useState(null); // State for selected wasam in Saving Certificate




    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedDistricDeposit, setSelectedDistricDeposit] = useState([]);
    const [selectedCustomerCount, setSelectedCustomerCount] = useState([]);
    const [selectedActiveandDormant, setSelectedActiveandDormant] = useState([]);

    const [selectedDepositBranch, setSelectedDepositBranch] = useState([]);
    const [selectedDepositDestrict, setSelectedDepositestrict] = useState([]);
    const [selectedMemberDeposit, setSelectedMemberDeposit] = useState([]);
    const [selectedDormantDeposit, setSelectedDormantDeposit] = useState([]);
    const [selectedActiveAccounts, setSelectedActiveAccounts] = useState([]);
    const [selectedActiveAccountwasam, setSelectedActiveAccountwasam] = useState([]);
    const [selectedActiveAccountproduct, setSelectedActiveAccountproduct] = useState([]);
    const [selectedReportproduct, setSelectedReportproduct] = useState([]);





    const [selectedShareDepositBranch, setSelectedShareDepositBranch] = useState(null);
    const [displayValue, setDisplayValue] = useState(null);

    const [branchesForSelectedDistrict, setBranchesForSelectedDistrict] = useState([])
    const [branchesForSelectedDivArea, setBranchesForSelectedDivArea] = useState([]);
    const [branchRadio, setBranchRadio] = useState(null);
    const [districtRadio, setDistrictRadio] = useState(null);
    const [selectedBranchName, setSelectedBranchName] = useState([]);
    const [divAreaData, setDivAreaData] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedBranchForDormantAndActive, setSelectedBranchForDormantAndActive] = useState(null);
    const [selectedBranchForDormantAndActiveProduct, setSelectedBranchForDormantAndActiveProduct] = useState(null);
    const [selectedBranchForCDPDTransaction, setSelectedBranchForCDPDTransaction] = useState(null);
    const [selectedBranchForCDPDTransactionDistrict, setSelectedBranchForCDPDTransactionDistrict] = useState(null);
    const [selectedBranchForMonthlyProductWiseDormant, setSelectedBranchForMonthlyProductWiseDormant] = useState(null);

    const [accountNumber, setAccountNumber] = useState("0");
    const [isValidAccountNumber, setIsValidAccountNumber] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [isStarting, setIsStarting] = useState(true);
    const [dormantWasamWiseLoading, setDormantWasamWiseLoading] = useState(false);
    const [fieldCollectionLoading, setFieldCollectionLoading] = useState(false);
    const [fieldCollectionProduct, setFieldCollectionProduct] = useState(null);
    const [fieldCollectionWasam, setFieldCollectionWasam] = useState(null);

    const [fieldCollectionDates, setFieldCollectionDates] = useState([]);
    const [savingCertificateDate, setSavingCertificateDate] = useState(null); // State for saving certificate date
    const [SavingCertificateLoading, setSavingCertificateLoading] = useState(false);

    const [multipleProduct, setMultipleProduct] = useState([]);
    const [districtDivisionalBranchData, setDistrictDivisionalBranchData] = useState([]);

    const [accountListLoading, setAccountListLoading] = useState(false);
    const [locationData, setLocationData] = useState({});


    const { Panel } = Collapse;
    const { Option } = Select;
    const { RangePicker } = DatePicker;


    const token = localStorage.getItem("accessToken")

    const loginPlaceId = localStorage.getItem("placeId")
    const decodeToken = token ? jwt_decode(token) : null;

    const districtName = loginPlaceId === "4" ? decodeToken.districtName : null;
    const branchId = decodeToken.branchId ? decodeToken.branchId : " "
    const divisionalID = loginPlaceId === "2" ? decodeToken.divAId : " ";
    const branchName = loginPlaceId === "1" ? localStorage.getItem("branch") : " "




    const sharedProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        placeholder: 'select one or more branches ',
        maxTagCount: 'responsive',
    };

    if (loginPlaceId === "4" || loginPlaceId === "3") {
        sharedProps.options = branchesForSelectedDistrict;
    } else if (loginPlaceId === "2") {
        sharedProps.options = branchesForSelectedDivArea;
    }

    const createDivAreaData = (data) => {
        return (data.map((post) => {
            return {
                divAId: post.divAId,
                divAIdCode: post.divAIdCode,
                divAIdName: post.divAIdName,
                districtId: post.districtId,
                branchDtoList: post.branchDtoList.map(e => {
                    return {
                        id: e.id,
                        branchCode: e.branchCode,
                        branchName: e.branchName
                    }
                })
            }
        }));
    };


    const existAccountByAccountNumber = () => {
        let data = {
            accountNumber: accountNumber,
            branchId: selectedBranch,
        }
        existAccount(data).then((res) => {
            setIsValidAccountNumber(res);
            setIsValidating(false);
        }).catch((err) => {
            errHandler(err);
        });
    };

    useEffect(() => {
        if (isValidating) {
            existAccountByAccountNumber();
        }
    }, [isValidating]);

    const handleAccountNumberChange = (e) => {
        if (isValidAccountNumber) {
            setIsValidAccountNumber(false);
        }
        setAccountNumber(e.target.value);
        if (e.target.value.length === 15) {
            setIsValidating(true);
        }
        if (isStarting) {
            setIsStarting(false);
        }
    };

    const handleBranchChange = (value) => {
        setSelectedBranch(value);
    };


    const handleBranchChangeForDormantAndActive = (value) => {
        setSelectedBranchForDormantAndActive(value);
    };

    const handleBranchChangeForDormantActiveProduct = (value) => {
        setSelectedBranchForDormantAndActiveProduct(value);
    }

    const handleBranchChangeForCDPDTransaction = (value) => {
        setSelectedBranchForCDPDTransaction(value);
    }

    const handleBranchChangeForCDPDTransactionDistrict = (value) => {
        setSelectedBranchForCDPDTransactionDistrict(value)
    }

    const handleBranchChangeForMonthlyProductWiseDormant = (value) => {
        setSelectedBranchForMonthlyProductWiseDormant(value);
    }

    const onRadioChange = (e) => {
        setBranchRadio(e.target.value);
    };

    const onRadioChange2 = (e) => {
        setDistrictRadio(e.target.value);
    };


    const onSwitchChange = (checked) => {
        setIsOn(checked);
    };

    const onSwitchChangeForDepositAndDormant = (checked) => {
        setIsExcelForDepositAndDormant(checked);
    }
    const onSwitchChangeForDepositAndDormantCumulative = (checked) => {
        setIsExcelForDepositAndDormantCumulative(checked);
    }

    const onSwitchChangeForOtherReports = (checked) => {
        setIsExcelForOtherReports(checked);
    }

    const onSwitchChangeDistrict = (checked) => {
        setIsOnDistrict(checked);
    };
    const onSwitchChangeShareDeposit = (checked) => {
        setIsOnShareDeposit(checked);
    };

    const onSwitchChangeAccount = (checked) => {
        setIsOnAccount(checked);
    }

    const onSwitchChangeOtherDeposits = (checked) => {
        setIsOnOtherDepositsDistrict(checked);
    };

    const onSwitchChangeShareAndMember = (checked) => {
        setIsOnShareAndMemberDistrict(checked);
    };

    const onSwitchChangeShareAndDormant = (checked) => {
        setIsOnShareAndDormantDistrict(checked);
    };

    const onSwitchChangeProductWiseBackDate = (checked) => {
        setIsProductWiseBackDate(checked);
    };

    const disabledDatesBeforeYear = current => {
        const currentDate = new Date();
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(currentDate.getFullYear() - 5);

        return current && (current > currentDate || current < oneYearAgo);
    };



    useEffect(() => {
        handleRadioChange(1);
    }, [branchesForSelectedDistrict, branchesForSelectedDivArea]);


    const handleDistrictRadioChange = (e) => {
        if (e.target.value === 1) {
            setSelectedDistrict(null);
        }
        setDistrictRadio(e.target.value);
    };

    const handleRadioChange = (value) => {
        setBranchRadio(value);
        if (loginPlaceId === "2") {
            if (branchesForSelectedDivArea) {
                const branches = branchesForSelectedDivArea.map((branch) => (
                    branch.value
                ))
                setSelectedBranches(branches);
            }
        } else {
            if (branchesForSelectedDistrict) {
                const branches = branchesForSelectedDistrict.map((branch) => (
                    branch.value
                ))
                setSelectedBranches(branches);
            }
        }


    }

    const handleDistrictSelect = (value) => {


        setSelectedDistrict(value);

        handleFilteredData(value)
    };

    const handleSelectedShareDepositDistrict = (value) => {


        if (value === 'all') {

            setselectedShareDepositDistrict("all");
        } else {

            setselectedShareDepositDistrict(value);
        }


    };


    useEffect(() => {

        if (selectedDistrict && districtBranchData.length > 0) {

            const selectedDistrictData = districtBranchData.find((district) => district.districtName === selectedDistrict);
            if (selectedDistrictData) {
                const branches = selectedDistrictData.branchDtoList.map((branch) => ({
                    key: `${branch.id}`,
                    value: `${branch.id}`,
                    label: `${branch.branchName}`
                }));
                setBranchesForSelectedDistrict(branches);

            }
        }
    }, [selectedDistrict, districtBranchData]);

    useEffect(() => {
        if (selectedDivisionalArea && divAreaData.length > 0) {
            const selectedDivisionalAreaData = divAreaData
                .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea));
            if (selectedDivisionalAreaData) {
                const branches = selectedDivisionalAreaData.branchDtoList.map((branch) => ({
                    key: `${branch.id}`,
                    value: `${branch.id}`,
                    label: `${branch.branchName}`
                }));
                setBranchesForSelectedDivArea(branches);
            }
        }
    }, [selectedDivisionalArea, divAreaData]);


    const handleBranchSelect = {

        selectedBranches,
        onChange: setSelectedBranches,
    };


    const handleDistricDepositSelect = {

        selectedDistricDeposit,
        onChange: setSelectedDistricDeposit,
    };
    const handleCustomerCountSelect = {

        selectedCustomerCount,
        onChange: setSelectedCustomerCount,
    };

    const handleActiveandDormantSelect = {

        selectedActiveandDormant,
        onChange: setSelectedActiveandDormant,
    };
    const handleDepositBranch = {

        selectedDepositBranch,
        onChange: setSelectedDepositBranch,
    };
    const handleDepositDestrict = {

        selectedDepositDestrict,
        onChange: setSelectedDepositestrict,
    };
    const handleMemberDeposit = {

        selectedMemberDeposit,
        onChange: setSelectedMemberDeposit,
    };
    const handleDormantDeposit = {

        selectedDormantDeposit,
        onChange: setSelectedDormantDeposit,
    };
    const handleActiveAccountwasam = {

        selectedActiveAccountwasam,
        onChange: setSelectedActiveAccountwasam,
    };
    const handleActiveAccounts = {

        selectedActiveAccounts,
        onChange: setSelectedActiveAccounts,
    };
    const handleReportproduct = {

        selectedReportproduct,
        onChange: setSelectedActiveAccountproduct,
    };
    const handleActiveAccountproduct = {

        selectedActiveAccountproduct,
        onChange: setSelectedActiveAccountproduct,
    };



    const handleShareCountSelect = (value) => {
        if (value === 'all') {
            setSelectedShareDepositBranch(null);
            setDisplayValue('All Branches');
        } else {
            setSelectedShareDepositBranch(value);
            setDisplayValue(value);
            setselectedShareDepositDistrict(null);
        }
    };

    const handleDateChange = (value) => {
        setSelectedDate(value);
    };

    const handleBsDateChange = (dates) => {
        setSelectedBsDates(dates);
    };
    const handleCdPdDateChange = (dates) => {
        SetselectCdPdDates(dates);
    };
    const handleBackDateChange = (dates) => {
        setSelectedBackDates(dates);
    };

    const handleWasamChange = (value) => {
        setSelectedWasam(value);
    };

    const handleProductChange = (value) => {
        setSelectedProduct(value);
    };


    const handleWasamWiseProductChange = (value) => {
        setSelectedWasamWiseProduct(value);
    };

    const handleMonthlyWiseProductChange = (value) => {
        console.log(value)
        setSelectedMonthlyProductWise(value);
    };

    const handleMonthlyDateChange = (dates) => {
        setSelectedMonthlyDates(dates);
    };

    const handleActiveStatusChange = (value) => {
        setSelectedStatus(value);
    };
    const handleActiveStatusWasamwiseChange = (value) => {
        setSelectedStatusWasamwise(value);
    };

    const handleTransactionTypeChange = (value) => {
        setSelectedTransactionType(value);
    };

    const handleAllOrWasamWiseChange = (value) => {
        setSelectedAllWasam(value);
    };


    const handleFieldCollectionProductChange = (value) => {
        setFieldCollectionProduct(value);
    };

    const handleFieldColectionWasmChange = (value) => {
        setFieldCollectionWasam(value);
    };
    const handleSavingCertificateWasmChange = (value) => {
        setSavingCertificateWasam(value);
    };

    const handleFieldCollectionDateChange = (dates) => {
        setFieldCollectionDates(dates);
    };

    const handleDormantDistrictSelect = (value) => {
        setSelectedDormantDistrict(value);
        handleFilteredData(value);
    };

    const handleOtherDepositDistrictSelect = (value) => {
        setSelectedOtherDepositDistrict(value);
        handleFilteredData(value)

    };

    const handleShareAndMemberDistrictSelect = (value) => {
        setSelectedShareAndMemberDistrict(value);
        handleFilteredData(value)

    };

    const handleShareAndDormantDistrictSelect = (value) => {
        setSelectedShareAndDormantDistrict(value);
        handleFilteredData(value)

    };

    const handleAccountDetailsDistrictSelect = (value) => {
        setSelectedAccountDetailsDistrict(value);
        handleFilteredData(value);
    }


    const handleFilteredData = (value) => {
        const filtered = districtBranchData.filter((district) =>
            district.districtName.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered)
    }

    const getAllWasam = () => {
        let branchId = decodeToken.branchId ? decodeToken.branchId : " ";
        getAllWasamsByBranchId(branchId).then((res) => {
            let data = createWasamData(res.data);
            setWasamData(data);
        }).catch((err) => {
            errHandler(err);
        })
    };

    const getAllDistrictDivisionalBranch = () => {
        getDistrictDivisionalBranchDetails().then((res) => {
            setDistrictDivisionalBranchData(res.data);
        }).catch((err) => {
            errHandler(err);
        })
    };


    const getAllBranchesByDistrict = () => {
        getDistrictBranches().then((res => {
            let data = createDistrictData(res.data);
            setDistrictBranchData(data)
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllBranchesByDivAId = () => {
        getDivAreaBranches().then((res => {
            let data = createDivAreaData(res.data);
            setDivAreaData(data);
        })).catch((err) => {
            errHandler(err)
        })
    }

    const generateDepositsSummaryReport = () => {
        let divAId = loginPlaceId === "2" ? selectedDivisionalArea : null;
        let selectedDistrictRadio = (loginPlaceId === "4") ? 1 : districtRadio;

        let data = {
            districtRadio: selectedDistrictRadio,
            districtName: selectedDistrict,
            divAId: divAId,
            // branchRadio: branchRadio,
            branchIdList: selectedBranches,
            selectedDate: districtDate,
            isExcel: isOnDistrict

        }
        setLoading(true);
        generateDepositSummaryReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setLoading(false)
        })

    };



    const generateDepositsCustomerCountReport = () => {
        let districtName = loginPlaceId === "3" ? selectedShareDepositDistrict : decodeToken.districtName;
        // let branchId = loginPlaceId === "4" ? selectedBranch : null;

        let data = {
            districtName: districtName,
            branchId: selectedShareDepositBranch,
            isExcel: isOnShareDeposit
        }

        setShareLoading(true);
        generateDepositCustomerCountReport(data).then((res) => {
            generateBlob(res.data);
        }).catch(err => {
            errHandler(err);
        }).finally(() => {
            setShareLoading(false);
        });
    }




    const generateAccountReport = () => {
        let data = {
            accountNumber: accountNumber,
            branchId: selectedBranch,
            isExcel: isOnAccount,
        }
        setAccountLoading(true);
        generateAccountDetailsReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            console.log(err)
            errHandler(err)
        }).finally(() => {
            setAccountLoading(false)
        })
    }

    const generateDepositsBranchReport = () => {
        let branchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let data = {
            branchId: branchId
        }
        setDistrictDepositLoading(true);
        generateDepositsummaryBranchReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDistrictDepositLoading(false)
        })

    };

    const generateDormantDepositsReport = () => {
        let selectedDistrictRadio = (loginPlaceId === "4") ? 1 : districtRadio;
        let data = {
            districtRadio: selectedDistrictRadio,
            districtName: selectedDistrict,
            branchIdList: selectedBranches,
            isExcel: isExcelForDepositAndDormant,
        }
        setDistrictLoading(true);
        generateDormantDepositSummaryReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDistrictLoading(false)
        })

    };
    const generateDormantDepositsByBranchReport = () => {
        let branchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let data = {
            branchId: branchId
        }
        setDistrictLoading(true);
        generateDormantDepositsCumulativeByBranchReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDistrictLoading(false)
        })

    };
    const generateDormantDepositsSummaryReport = () => {
        let selectedDistrictRadio = (loginPlaceId === "4") ? 1 : districtRadio;
        let data = {
            districtRadio: selectedDistrictRadio,
            districtName: selectedDistrict,
            branchIdList: selectedBranches,
            isExcel: isExcelForDepositAndDormantCumulative,
        }
        setDistrictsLoading(true);
        generateDormantDepositsCumulativeReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDistrictsLoading(false)
        })

    };
    const generateDormantDepositsSummaryBranchReport = () => {
        let data = {
            branchId: decodeToken.branchId ? decodeToken.branchId : selectedBranch
        }
        setDistrictsLoading(true);
        generateDormantDepositsCumulativeBranchReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDistrictsLoading(false)
        })

    };

    const generateSamurdhiBankDepositsReport = () => {
        let data = {
            districtName: selectedDistrict,
            districtRadio: districtRadio,
            isExcel: isOn
        }
        setDepositLoading(true);
        generateSamurdhiBankDepositSummaryReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDepositLoading(false)
        })

    };


    const generateSamurdhiBankOtherDepositsReport = () => {
        let data = {
            isExcel: isExcelForOtherReports,
        }
        setOtherDepositLoading(true);
        generateSamurdhiBankOtherDepositSummaryReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setOtherDepositLoading(false)
        })

    };

    const generateSamurdhiBankProductWiseDepositsReport = () => {
        let branchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let data = {
            branchId: branchId
        }
        setProductWiseLoading(true);
        generateSamurdhiBankProductWiseReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setProductWiseLoading(false)
        })

    };

    const generateSamurdhiBankShareAccount = () => {
        let data = {
            districtName: selectedDistrict,
            districtRadio: districtRadio,
            isExcel: isOnShareAndMemberDistrict,
        }
        setProductWiseLoading(true);
        generateSamurdhiBankShareAccountReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setProductWiseLoading(false)
        })

    };

    const generateShareAccountReportDistrictWise = () => {
        let districtName = loginPlaceId === "3" ? selectedShareAndMemberDistrict : decodeToken.districtName;
        let data = {
            districtName: districtName,
            isExcel: isOnShareAndMemberDistrict
        }
        setShareAccountLoading(true);
        generateSamurdhiBankShareAccountReportDistrictWise(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setShareAccountLoading(false)
        })

    };

    const generateOtherDepositsReportDistrictWise = () => {
        let districtName = loginPlaceId === "3" ? selectedDormantDistrict : decodeToken.districtName;
        let data = {
            districtName: districtName,
            selectedDate: otherDistrictDate,
            isExcel: isOn
        }
        setOtherDistrictLoading(true);
        generateSamurdhiBankOtherDepositsDistrictWise(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setOtherDistrictLoading(false)
        })

    };


    const generateOtherAccountReportDistrictWise = () => {
        let districtName = loginPlaceId === "3" ? selectedOtherDepositDistrict : decodeToken.districtName;
        let data = {
            districtName: districtName,
            isExcel: isOnOtherDepositsDistrict
        }
        setOtherAccountLoading(true);
        generateSamurdhiBankOtherAccountDistrictWise(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setOtherAccountLoading(false)
        })

    };

    const generateWasamWiseReports = () => {
        let data = {
            branchId: decodeToken.branchId ? decodeToken.branchId : " "
        }
        setShareDormantLoading(true);
        generateWasamReports(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setShareDormantLoading(false)
        })

    };

    const generateActiveDormantReports = () => {
        let branchId = loginPlaceId === "2" || loginPlaceId === "4" ? selectedBranchForDormantAndActive : decodeToken.branchId;
        let data = {
            branchId: branchId,
            productId: selectedProduct,
            activeStatus: selectedStatus,
            selectedDate: dormantActiveDate

        }
        setDormantAndActiveLoading(true);
        generateActiveAndDormantDeposits(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setDormantAndActiveLoading(false)
        })

    };

    const generateActiveDormantWasamWiseReports = () => {
        let branchId = loginPlaceId === "2" || loginPlaceId === "4" || loginPlaceId === "3" ? locationData.branchId : decodeToken.branchId;
        let data = {
            branchId: branchId,
            wasamId: (loginPlaceId === "2" || loginPlaceId === "4" || loginPlaceId === "3") ? "0" : selectedWasam,
            productId: selectedProduct,
            activeStatus: selectedStatusWasamwise,
            selectedDate: dormantActiveWasamwiseDate
        }
        setDormantWasamWiseLoading(true);
        if (data.wasamId === "0") {
            generateActiveAndDormantwasamwiseDeposits(data).then((res) => {
                generateBlob(res.data)
            }).catch(err => {
                errHandler(err)
            }).finally(() => {
                setDormantWasamWiseLoading(false)
            })
        }
        else {
            generateActiveAndDormantwasamwise(data).then((res) => {
                generateBlob(res.data)
            }).catch(err => {
                errHandler(err)
            }).finally(() => {
                setDormantWasamWiseLoading(false)
            })

        }

    };

    const generateActiveDormantProductWiseBackdateReports = () => {
        let branchId = loginPlaceId === "2" || loginPlaceId === "4" || loginPlaceId === "3" ? selectedBranchForDormantAndActiveProduct : decodeToken.branchId;
        const [startDate, endDate] = selectedBackDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            branchId: branchId,
            productIdList: multipleProduct,
            activeStatus: selectedStatus,
            wasamIdList: selectedWasam
        }
        setLoading(true);
        generateBackdateActiveAndDormantReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setLoading(false)
        })

    };
    const generateCDPDReports = () => {
        let branchId = loginPlaceId === "2" || loginPlaceId === "4" || loginPlaceId === "3" ? locationData.branchId : decodeToken.branchId;

        const [startDate, endDate] = selectedBsDates;
        let data = {
            branchId: branchId,
            selectedDate: startDate,
            endDate: endDate,
            wasamIdList: selectedWasam,
            transactionType: selectedTransactionType,
            productIdList: multipleProduct
        }
        setCdpdLoading(true);
        generateCDPDReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setCdpdLoading(false);
        })
    }
    const generateCDPDWasamWiseReports = () => {
        const [startDate, endDate] = selectedBsDates;
        let branchId = loginPlaceId === "2" ? selectedBranchForCDPDTransaction
            : loginPlaceId === "4" ? selectedBranchForCDPDTransactionDistrict
                : decodeToken.branchId;

        let data = {
            branchId: branchId,
            selectedDate: startDate,
            endDate: endDate,
            transactionType: selectedTransactionType,
            productId: selectedProduct
        }
        setCdpdWasamWiseLoading(true);
        generateCDPDWasamWiseReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setCdpdWasamWiseLoading(false);
        })
    }

    const generateAllWasamReport = () => {
        let branchId = loginPlaceId === "2" ? selectedBranchForMonthlyProductWiseDormant : decodeToken.branchId;
        const [startDate, endDate] = selectedMonthlyDates;
        let data = {
            branchId: branchId,
            selectedDate: startDate,
            endDate: endDate,
            wasamIdList: selectedWasam,
            productIdList: multipleProduct
        }
        setMonthlyLoading(true);
        generateMonthlyAllWasamReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setMonthlyLoading(false);
        })
    }

    const generateFieldCollectionReport = () => {
        const [startDate, endDate] = fieldCollectionDates;

        // Always use arrays
        let productIdList = [];
        let wasamIdList = [];

        // Handle Products
        if (multipleProduct.includes("-1")) {
            // If "ALL" selected, get all product IDs
            productIdList = depositsProducts.map(p => parseInt(p.productId));
        } else {
            productIdList = multipleProduct.map(id => parseInt(id));
        }

        // Handle Wasam
        if (selectedWasam.includes("-1")) {
            // If "ALL" selected, get all wasam IDs
            wasamIdList = wasamData.map(w => parseInt(w.wastId));
        } else {
            wasamIdList = selectedWasam.map(id => parseInt(id));
        }

        const data = {
            branchId: loginPlaceId === "1" ? decodeToken.branchId : selectedBranchForCDPDTransactionDistrict,
            selectedDate: startDate,
            endDate: endDate,
            productIdList,
            wasamIdList
        };

        setFieldCollectionLoading(true);
        fieldCollectionReport(data)
            .then((res) => generateBlob(res.data))
            .catch(err => errHandler(err))
            .finally(() => setFieldCollectionLoading(false));
    };



    const generateSavingCertificateReport = () => {
        let data = {
            branchId: decodeToken.branchId,
            selectedDate: savingCertificateDate.format('YYYY-MM-DD'),
            productId: savingCertificateProduct,
            wasamId: savingCertificateWasam
        }
        setSavingCertificateLoading(true);
        SavingCertificateReport(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setSavingCertificateLoading(false);
        })
    }
    const getAllDeposits = () => {
        getAllDepositsProducts().then((res) => {
            let data = createDepositsProductData(res.data);
            setDepositsProducts(data);
        }).catch((err) => {
            errHandler(err);
        })
    }


    useEffect(() => {
        // getAllDistricts();
        getAllDeposits();
        getAllBranchesByDistrict();
        getAllDistrictDivisionalBranch()
        if (loginPlaceId === "1") {
            getAllWasam();

        } else if (loginPlaceId === "4") {
            handleDistrictSelect(decodeToken.districtName);

        } else if (loginPlaceId === "2") {
            getAllBranchesByDivAId();
            setSelectedDivisionalArea(decodeToken.divAId);
        } else if (loginPlaceId === "3") {
            getAllBranchesByDivAId();
        }

    }, []);


    return (
        <>
            <div>
                <h3>Deposits</h3>
            </div>
            <Collapse className="collapse-report">

                <PermissionPanel
                    permission="accountListView"
                    placeIds={["1", "2", "3", "4"]}
                    header="Account List Retrieval"
                    key="accountListView"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1" ? '' : 'hidden'}`}
                >
                    <div className="panel-container">
                        <AccountList
                            loginPlaceId={loginPlaceId}
                            districtData={districtDivisionalBranchData}
                            districtName={districtName}
                            divisionalId={divisionalID}
                            branchId={branchId}
                            products={depositsProducts}
                            getAllAccountList={getAllAccountList}
                            loading={accountListLoading}
                            setLoading={setAccountListLoading}
                        />
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    header="Closed Accounts Report"
                    permission="accountListView"
                    placeIds={["1", "2", "3", "4"]}
                    key="closed-accounts"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1" ? '' : 'hidden'}`}
                >
                    <ClosedAccounts
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                        getAllClosedAccounts={getAllClosedAccounts}
                        generateBlob={generateBlob}
                        errHandler={errHandler}
                    />
                </PermissionPanel>

                <PermissionPanel
                    header="Inactive Accounts Report"
                    permission="accountListView"
                    placeIds={["1", "2", "3", "4"]}
                    key="inactive-accounts"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1" ? '' : 'hidden'}`}
                >
                    <InactiveAccounts
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="depositSummary"
                    placeIds={["1", "2", "3", "4"]}
                    key="depositSummary"
                    header="District And Branch Deposits Excel"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1") ? '' : 'hidden'}`}>
                    <DistrictReport loginPlaceId={loginPlaceId} loading={loading} products={depositsProducts} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} branchId={branchId} />
                </PermissionPanel>

                <PermissionPanel
                    permission="branchDepositReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Branch Deposit Report"
                    key="branchDepositReport"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />
                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateDepositsBranchReport} disabled={districtDepositLoading ||
                                                (loginPlaceId !== "1" && !locationData.branchId)} className="generate-btn">
                                                {districtDepositLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    placeIds={["1", "2"]}
                    permission="branchDepositReport"
                    header="Dormant & Active Deposits Summary (Cumulative)"
                    key="branchDepositReport1"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateDormantDepositsSummaryBranchReport} disabled={districtsLoading} className="generate-btn">
                                                {districtsLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="summaryDepositsActiveAndDormant"
                    placeIds={["1", "2", "3", "4"]}
                    header="Summary - Deposits Active & Dormant (Cumulative)"
                    key="summaryDepositsActiveAndDormant"
                    className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />

                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateDormantDepositsByBranchReport} disabled={districtLoading ||
                                                (loginPlaceId !== "1" && !locationData.branchId)} className="generate-btn">
                                                {districtLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="districtAndIslandDepositSummary"
                    placeIds={["3"]}
                    header="Samurdhi Banks District And Island Deposits Summary"
                    key="districtAndIslandDepositSummary"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}
                >
                    <DepositSummaryIslandReport
                        loginPlaceId={loginPlaceId}
                        loading={loading}
                        districtData={districtBranchData}
                        divAreaData={divAreaData}
                        districtName={districtName}
                    />
                </PermissionPanel>



                <PermissionPanel
                    permission="districtWiseOtherDeposits"
                    placeIds={["3"]}
                    header="District Wise Other Deposits"
                    key="districtWiseOtherDeposits"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeForOtherReports} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateSamurdhiBankOtherDepositsReport} disabled={otherDepositLoading} className="generate-btn">
                                                {otherDepositLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="productWiseDepositReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Product Wise Deposit Report"
                    key="productWiseDepositReport"
                    className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />

                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateSamurdhiBankProductWiseDepositsReport ||
                                                (loginPlaceId !== "1" && !locationData.branchId)} disabled={productWiseLoading} className="generate-btn">
                                                {productWiseLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="samurdhiBanksDormantOtherDepositsBranchWise"
                    placeIds={["4", "3"]}
                    header="Samurdhi Banks Dormant Other Deposits Branch Wise"
                    key="samurdhiBanksDormantOtherDepositsBranchWise"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3") ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDormantDistrict}
                                                    onChange={handleDormantDistrictSelect}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setOtherDistrictDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChange} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateOtherDepositsReportDistrictWise} disabled={otherDistrictLoading || !otherDistrictDate} className="generate-btn">
                                                {otherDistrictLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="accountTrailBalance "
                    placeIds={["1", "2", "4"]}
                    header="Account Trail Balance"
                    key="accountTrailBalance"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" || loginPlaceId === "4" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranchForDormantAndActive} onChange={handleBranchChangeForDormantAndActive} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        {(selectedDistrict || (selectedDivisionalArea && divAreaData.length > 0)) && loginPlaceId === "4" && (
                                            <Form.Item label="Select">
                                                <Space
                                                    direction="vertical"
                                                    style={{ width: '100%' }}
                                                >
                                                    <Select
                                                        value={selectedBranchForDormantAndActive}
                                                        onChange={handleBranchChangeForDormantAndActive}
                                                        style={{ width: '100%' }}
                                                        dropdownStyle={{ maxHeight: 200, overflow: 'auto' }} >
                                                        {branchesForSelectedDistrict.map((branches) => (
                                                            <Option key={branches.key} value={branches.value}>
                                                                {branches.label}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Space>
                                            </Form.Item>
                                        )}
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Active">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleActiveStatusChange}
                                                options={activeStatus} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select value={selectedProduct} onChange={handleProductChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select Header --</Option>
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setDormantActiveDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateActiveDormantReports} disabled={dormantAndActiveLoading || !dormantActiveDate} className="generate-btn">
                                                {dormantAndActiveLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>


                <PermissionPanel
                    permission="accountTrailBalanceWasamWise"
                    placeIds={["1", "2", "3", "4"]}
                    header="Account Trail Balance Wasam Wise"
                    key="accountTrailBalanceWasamWise"
                    className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />
                                    <Col span={24}>
                                        <Form.Item label="Active">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleActiveStatusWasamwiseChange}
                                                options={activeStatus}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {loginPlaceId === "1" && (
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select value={selectedWasam} onChange={handleWasamChange} style={{ width: '100%' }}>
                                                    <Option value="0">All </Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            {wasam.wasName}-{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select value={selectedProduct} onChange={handleProductChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select Header --</Option>
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setDormantActiveWasamwiseDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateActiveDormantWasamWiseReports} disabled={dormantWasamWiseLoading ||
                                                (loginPlaceId !== "1" && !locationData.branchId)} className="generate-btn">
                                                {dormantWasamWiseLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="activeAndDormantBackDateReport"
                    placeIds={["1", "2", "4", "3"]}
                    header="Active/Dormant Account Back-Date Report"
                    key="activeAndDormantBackDateReport"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" || loginPlaceId === "4" || loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDistrict}
                                                    onChange={handleDistrictSelect}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {(loginPlaceId === "4" || loginPlaceId === "3") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranchForDormantAndActiveProduct} onChange={handleBranchChangeForDormantActiveProduct} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchesForSelectedDistrict.length > 0 &&
                                                        branchesForSelectedDistrict.map((branch) => (
                                                            <Option key={branch.key} value={branch.value}>
                                                                {branch.label}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranchForDormantAndActiveProduct} onChange={handleBranchChangeForDormantActiveProduct} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Active">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleActiveStatusChange}
                                                options={activeDormantAllStatus}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {loginPlaceId === "1" && (
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select
                                                    mode="multiple" value={selectedWasam} onChange={(values) => {
                                                        if (values.includes('ALL')) {
                                                            setSelectedWasam(wasamData.map(b => b.wastId));
                                                        } else {
                                                            setSelectedWasam(values);
                                                        }
                                                    }}
                                                    disabled={wasamData.length === 0} style={{ width: '100%' }}>
                                                    <Option value="ALL">All Wasam</Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            🏙️  {wasam.wasName}--{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select value={multipleProduct} mode="multiple" onChange={(values) => {
                                                if (values.includes('ALL')) {
                                                    setMultipleProduct(depositsProducts.map(b => b.productId));
                                                } else {
                                                    setMultipleProduct(values);
                                                }
                                            }} style={{ width: '100%' }}>
                                                <Option value="ALL">All Products</Option>
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        🏙️  {product.productCode}-{product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Date Range">
                                            <RangePicker onChange={handleBackDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    {/* <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeProductWiseBackDate} />
                                        </Form.Item>
                                    </Col> */}
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateActiveDormantProductWiseBackdateReports} disabled={loading} className="generate-btn">
                                                {loading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>


                <PermissionPanel
                    permission="cdPd"
                    placeIds={["1","2","3","4"]}
                    header="CD PD CW LP Transaction Report Wasam and Product Wise"
                    key="cdPd"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "2" || loginPlaceId === "3" || loginPlaceId === "4"  ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                 <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />

                                    <Col span={24}>
                                        <Form.Item label="Date Range">
                                            <RangePicker onChange={handleBsDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Transaction Type">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleTransactionTypeChange}
                                                options={transactionType}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {loginPlaceId === "1" && (
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select
                                                    mode="multiple" value={selectedWasam} onChange={(values) => {
                                                        if (values.includes('ALL')) {
                                                            setSelectedWasam(wasamData.map(b => b.wastId));
                                                        } else {
                                                            setSelectedWasam(values);
                                                        }
                                                    }}
                                                    disabled={wasamData.length === 0} style={{ width: '100%' }}>
                                                    <Option value="ALL">All Wasam</Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            🏙️  {wasam.wasName}--{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select value={multipleProduct} mode="multiple" onChange={(values) => {
                                                if (values.includes('ALL')) {
                                                    setMultipleProduct(depositsProducts.map(b => b.productId));
                                                } else {
                                                    setMultipleProduct(values);
                                                }
                                            }} style={{ width: '100%' }}>
                                                <Option value="ALL">All Products</Option>
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        🏙️  {product.productCode}-{product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateCDPDReports} disabled={cdpdLoading || !selectedBsDates} className="generate-btn">
                                                {cdpdLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="monthlyProductWiseDormantReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Monthly Product Wise Dormant Report"
                    key="monthlyProductWiseDormantReport" className={`collapse-panel`}>
                    <MonthlyDormantDeposits loginPlaceId={loginPlaceId} products={depositsProducts} districtData={districtDivisionalBranchData}
                        districtName={districtName} branchId={branchId} divisionalId={divisionalID} wasamData={wasamData} />
                </PermissionPanel>

                <PermissionPanel
                    permission="accountDetails"
                    placeIds={["3"]}
                    header="Account Details Report"
                    key="accountDetails"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDistrict}
                                                    onChange={handleDistrictSelect}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange}
                                                    style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchesForSelectedDistrict.length > 0 &&
                                                        branchesForSelectedDistrict.map((branch) => (
                                                            <Option key={branch.key} value={branch.value}>
                                                                {branch.label}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form name="trigger">
                                            <Form.Item
                                                hasFeedback
                                                label="Enter Account Number"
                                                name="accountNum"
                                                validateStatus={`${isValidAccountNumber ? "success" : isValidating ? "validating" : isStarting ? "" : "error"}`}
                                                help={`${isValidAccountNumber ? "Account number matches" : isValidating ? "" : isStarting ? "" : "Account number not matches"}`}
                                            >
                                                <Input
                                                    disabled={!selectedBranch}
                                                    placeholder="Account Number"
                                                    value={accountNumber}
                                                    onChange={handleAccountNumberChange}
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                    <div style={{ height: '80px' }}></div>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeAccount} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateAccountReport}
                                                disabled={accountLoading || !isValidAccountNumber}
                                                className="generate-btn">
                                                {accountLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="fieldCollectionReport"
                    placeIds={["1", "4"]}
                    header="Field Collection"
                    key="fieldCollectionReport" className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {(loginPlaceId === "4") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranchForCDPDTransactionDistrict} onChange={handleBranchChangeForCDPDTransactionDistrict} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchesForSelectedDistrict.length > 0 &&
                                                        branchesForSelectedDistrict.map((branch) => (
                                                            <Option key={branch.key} value={branch.value}>
                                                                {branch.label}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Date Range">
                                            <RangePicker onChange={handleFieldCollectionDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    {(loginPlaceId === "1") && (
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    value={selectedWasam}
                                                    onChange={(values) => {
                                                        if (values.includes("all")) {
                                                            setSelectedWasam(["-1"]);
                                                        } else {
                                                            setSelectedWasam(values);
                                                        }
                                                    }}
                                                    style={{ width: '100%' }}
                                                    dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}
                                                >
                                                    <Option value="-1">All</Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            {wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select
                                                mode="multiple"
                                                allowClear
                                                value={multipleProduct}
                                                onChange={(values) => {
                                                    if (values.includes("all")) {
                                                        setMultipleProduct(["-1"]);
                                                    } else {
                                                        setMultipleProduct(values);
                                                    }
                                                }}
                                                style={{ width: '100%' }}
                                                dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}
                                            >
                                                <Option value="-1">ALL</Option>
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateFieldCollectionReport} disabled={fieldCollectionLoading || !fieldCollectionDates} className="generate-btn">
                                                {fieldCollectionLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>
                {/* new saving panel */}
                <PermissionPanel
                    permission="accountCertificate"
                    placeIds={["1"]}
                    header="Saving Certificate" key="accountCertificate" className={`collapse-panel ${loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {(loginPlaceId === "4") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranchForCDPDTransactionDistrict} onChange={handleBranchChangeForCDPDTransactionDistrict} style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchesForSelectedDistrict.length > 0 &&
                                                        branchesForSelectedDistrict.map((branch) => (
                                                            <Option key={branch.key} value={branch.value}>
                                                                {branch.label}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setSavingCertificateDate(date)} disabledDate={disabledDatesBeforeYear} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    {/*wasam*/}
                                    {(loginPlaceId === "1") && (
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select value={savingCertificateWasam} onChange={handleSavingCertificateWasmChange} style={{ width: '100%' }}>
                                                    <Option value={null}>All</Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            {wasam.wasName}--{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}




                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select
                                                value={savingCertificateProduct}
                                                onChange={(value) => setSavingCertificateProduct(value)}
                                                style={{ width: '100%' }}
                                                placeholder="Select Product"
                                            >
                                                {depositsProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateSavingCertificateReport} disabled={SavingCertificateLoading || !savingCertificateDate} className="generate-btn">
                                                {SavingCertificateLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>
                <PermissionPanel
                    permission="financialProductWiseSummary"
                    placeIds={["4", "3", "1"]}
                    header="Financial Product Wise Summary Excel"
                    key="financialProductWiseSummary"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "1") ? '' : 'hidden'}`}
                >
                    <ProductWiseReports loginPlaceId={loginPlaceId} loading={loading} products={depositsProducts} districtData={districtBranchData} districtName={districtName} branchId={branchId} wasamData={wasamData} />
                </PermissionPanel>

                <PermissionPanel
                    permission="shareAndMemberSummaryExcel"
                    placeIds={["4", "3"]}
                    header="Share and Member Deposits Report Excel"
                    key="shareAndMemberSummaryExcel" className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3") ? '' : 'hidden'}`}>
                    <ShareMemberDReport loginPlaceId={loginPlaceId} loading={loading} products={depositsProducts} districtData={districtBranchData} districtName={districtName} />
                </PermissionPanel>

                <PermissionPanel
                    permission="depositSummaryExcel"
                    placeIds={["4", "3"]}
                    header="Deposit Summary Report Excel"
                    key="depositSummaryExcel"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3") ? '' : 'hidden'}`}>
                    <DepositSummary loginPlaceId={loginPlaceId} loading={loading} products={depositsProducts} districtData={districtBranchData} districtName={districtName} />
                </PermissionPanel>

                <PermissionPanel permission="otherDepositsSummaryExcel" placeIds={["4", "3", "2", "1"]} key="otherDepositsSummaryExcel" header="Other Deposits Report" className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1") ? '' : 'hidden'}`}>

                    <OtherDReport
                        loginPlaceId={loginPlaceId}
                        loading={loading}
                        products={depositsProducts}
                        districtData={districtBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>


                <PermissionPanel
                    permission="fieldCollectionReportExcel"
                    placeIds={["4", "3", "2", "1"]}
                    header="Field Collection Summary Excel"
                    key="fieldCollectionReportExcel"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1") ? '' : 'hidden'}`}>
                    <FieldCollectionSummary loginPlaceId={loginPlaceId} loading={loading} products={depositsProducts} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} branchId={branchId} wasamData={wasamData} />
                </PermissionPanel>


                <PermissionPanel
                    permission="interestPaymentReportExcel"
                    placeIds={["1"]}
                    header="Interest Payment Report Excel"
                    key="interestPaymentReportExcel"
                    className={`collapse-panel ${(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1") ? '' : 'hidden'}`}>
                    <InterestPay
                        loginPlaceId={loginPlaceId}
                        products={depositsProducts}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        branchId={branchId}
                        divisionalId={divisionalID}
                        wasamData={wasamData}
                        branchName={branchName}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="openAccountDataReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Open Account Data Report"
                    key="openAccountDataReport"
                    className={`collapse-panel`}
                >
                    <OpenAccountReport
                        products={depositsProducts}
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                        branchName={branchName}
                        wasamData={wasamData}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="openAccountDataReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Non-Priority Customer Accounts"
                    key="nonPriorityCustomerAccounts"
                    className={`collapse-panel`}
                >
                    <NonPriorityCustomerAccountsReport
                        products={depositsProducts}
                        loginPlaceId={loginPlaceId}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <CustomFooter />

            </Collapse>
        </>
    )
};
export default Savings;